/* eslint-disable camelcase */
import axios from 'axios';
import BaseComponent from 'scripts/BaseComponent.js';

export default class HatboxProductOptions extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      optionBtn: '.js-hatboxProductOption',
      optionSwatchImg: '.js-hatboxProductOptionSwatchImage',
      sizeGuideToggleBtn: '.js-sizeGuideToggleBtn',
      json: '.js-filteredHatboxProductsJson',
    };

    this.dom = {
      $component: component,
      $optionBtns: this.$getAll(this.refs.optionBtn),
      $sizeGuideToggleBtn: this.$get(this.refs.sizeGuideToggleBtn),
    };

    this.state = {
      openSizeGuideModalEvent: 'opensizeguidemodal',
      imageLoadedClass: 'image-loaded',
      sizeUnavailableClass: 'size-unavailable',
    };

    this.init();
    this.mount();
  }

  init() {
    this.fetchSizeSwatchImages();
  }

  mount() {
    const { dom } = this;
    super.mount();

    this.setClick(dom.$sizeGuideToggleBtn, this.openSizeGuideModal);
  }

  async fetchSizeSwatchImages() {
    const { dom, refs } = this;
    const { shape, material } = dom.$component.dataset;
    const url = `/collections/all?view=filtered-hatboxes&filter.p.m.custom.hatbox_shape=${shape}&filter.v.option.box%20material=${material}`;

    try {
      const { data } = await axios.get(url);
      const parser = new DOMParser();
      const page = parser.parseFromString(data, 'text/html');
      const json = page.querySelector(refs.json);
      const hatboxData = JSON.parse(json.innerHTML);

      this.setSizeSwatchImages(hatboxData);
    } catch (e) {
      console.log('Error fetching related hatbox material images', e);
    }
  }

  setSizeSwatchImages(hatboxData) {
    const { dom } = this;

    dom.$optionBtns.forEach((btn) => this.setSizeSwatchImage(btn, hatboxData));
  }

  setSizeSwatchImage(btn, { products }) {
    const { state, refs } = this;
    const { size } = btn.dataset;

    const relatedSizeHatbox = products
      .find((product) => product.size === size);
    if (!relatedSizeHatbox) {
      btn.classList.add(state.imageLoadedClass);
      btn.classList.add(state.sizeUnavailableClass);
      return;
    }

    const displayVariant = relatedSizeHatbox.variants
      .find(({ rose_color }) => rose_color === 'Pure White');
    const swatchImageVariant = displayVariant
      || relatedSizeHatbox.variants.find(({ featured_image }) => featured_image);

    const swatchImage = new Image();
    swatchImage.src = swatchImageVariant.featured_image;
    swatchImage.addEventListener('load', () => {
      btn.querySelector(refs.optionSwatchImg)
        .setAttribute('src', swatchImageVariant.featured_image);
      btn.classList.add(state.imageLoadedClass);
    });
  }

  openSizeGuideModal() {
    const { state: { openSizeGuideModalEvent } } = this;
    this.dispatch(openSizeGuideModalEvent);
  }
}
